"use strict";

var Graphics = require('pixi.js').Graphics;
var Sprite = require('pixi.js').Sprite;
const _ = require('lodash');
const Entity = require('./Entity.js').Entity;
const Throttler = require('../util/Throttler.js').Throttler;
const timestamp = require('../util/Timer.js').timestamp;
const TWEEN = require('tween.js');
const snapToGrid = require('../util/utils.js').snapToGrid;

export let Fruit = function(options){
	Entity.call(this, options);

	const timeToLive = Math.round(Math.random() * 6 + 3);

	this.removeThrottler = new Throttler(timeToLive, () => {

		const end = { x: 0, y: 0 };
		let tween = new TWEEN.Tween(this.graphics.scale).to(end, 1000);
		tween.easing(TWEEN.Easing.Elastic.InOut);
		tween.onComplete(() => {
			this.alive = false;
		});

		tween.start();
	});
}


Fruit.generateNewFruit = function(options) {
	options = _.defaults(options, {
		x: snapToGrid(Math.round(Math.random() * 832 + 16)),
		y: snapToGrid(Math.round(Math.random() * 832 + 16))
	});
	console.log("New fruit at:", options.x, options.y);

	return new Fruit(options);
}

Fruit.prototype = Object.create(Entity.prototype);
Fruit.prototype.constructor = Fruit;

Fruit.prototype.update = function(dt) {
	this.removeThrottler.update(dt);
};


Fruit.prototype.createGraphics = function() {
	// draw a shape
	let graphics = new Graphics();
	graphics.lineStyle(1, 0xBB0033, 0.1);
	graphics.beginFill(0xFF0033, 1);

	graphics.drawRoundedRect(0, 0, this.width, this.height, this.radius);
	graphics.endFill();
	graphics.x = this.x;
	graphics.y = this.y;

	graphics = new Sprite(graphics.generateTexture(false));
	graphics.anchor.set(0.5, 0.5);
	graphics.scale.set(0, 0);
	return graphics;
};






/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/entities/Fruit.js
 **/